import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'; 
import {store, persistor} from './redux/store'; 
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from "react-query";
import './index.scss';
import App from './App';

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(

    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </QueryClientProvider>
    </Provider>

);
